import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/admin/ui/ConfirmDialog';

// The email is shown so staff can tell two students with the same name apart
// before refusing one of them.
export function DenySwitchDialog({
  open,
  studentName,
  studentEmail,
  pending,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  studentName: string;
  studentEmail: string;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}): ReactElement {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      title={t('admin.waiting.deny.title')}
      confirmLabel={t('admin.waiting.action.deny')}
      tone="danger"
      pending={pending}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <p>
        {t('admin.waiting.deny.body', {
          name: studentName,
          interpolation: { escapeValue: false },
        })}
      </p>
      <p>
        {t('admin.waiting.studentEmail')}: <strong>{studentEmail}</strong>
      </p>
    </ConfirmDialog>
  );
}
